"use strict";

const emptyIter = function* () {}();

module.exports = emptyL;

function emptyL() {
  return emptyIter;
}

;